import { PatientApiService } from "./api/PatientApiService";
import { PatientMockService } from "./mock/PatientMockService";
import { LegalApiService } from "./api/LegalApiService";
import { LegalMockService } from "./mock/LegalMockService";
import { IPatientService } from "./IPatientService";
import { ILegalService } from "./ILegalService";

const env = (window as any).ENV || {};

export const patientService: IPatientService = env.FEATURE_PATIENTS_USE_MOCK
  ? new PatientMockService()
  : new PatientApiService();

export const legalService: ILegalService = env.FEATURE_LEGAL_USE_MOCK
  ? new LegalMockService()
  : new LegalApiService();
